import { SearchParams } from '../bzit';
import { defaultCurrency } from './env';

export type SearchForm = SearchParams;

export const searchForm: SearchForm = {
  vehicleIds: [],
  namesManufacturer: [],
  namesModel: [],
  codeUsage: '',
  codeBody: '',
  nameEuronorm: '',
  nameCurrency: defaultCurrency,
  codeLocation: '',
  codeCountry: '',
  codeWheelpos: '',
  registrationFrom: 0,
  registrationTo: 0,
  seatFrom: 0,
  seatTo: 0,
  milageFrom: 0,
  milageTo: 0,
  priceFrom: 0,
  priceTo: 0,
  codesClassification: [],
  onlyOfferVehicles: false,
  locale: ''
};
